<template>    
    <BaseModal
        :id="'static-update'"
        :title="title_modal"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />

                <hr/>
                    <div class="modal-title w-100">
                        <h2 class="title--1" v-html="'Default project logic'"/>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text" v-html="'Select a combination of Floor Type and Daily Task to define the default Project Task assignment for this room.'"/>
                        <div class="alert alert-warning pl-2 pr-2 mt-3" role="alert" v-if="suggested_floor_type && single_object && suggested_floor_type.id != single_object.floor_id">
                            <i class="fa fa-info-circle mr-2" style="font-size: 15px;"/> Please consider changing the floor type to <b>{{suggested_floor_type['name']}}</b>, this is the default floor type for the selected room type. To change it 
                            <a href="JavaScript:void(0);" @click="single_object.floor_id = suggested_floor_type.id" v-html="'Click here'" />
                        </div> 
                    </div>
                    

    
                    <FormDynamic
                        :form_format="form_format2"
                        :form_data="single_object"
                        :array_options="array_options"
                        :for_update="true"
                    />
                <hr/>

                <div class="p-0 formdynamic__item col-md-auto">
                    <div class="formdynamic__item__field position-relative operator">
                        <label for="Time adjustment:" class="modal-label active" v-html="single_object.patient ? 'Fixtures/Beds:' : '# of units'"/>
                        <button type="button" class="button__operator" v-html="'+'" @click="single_object.fixture_number++"/>
                        <button type="button" class="button__operator" v-html="'-'" @click="single_object.fixture_number--"/>
                        <input type="number" class="input__operator" v-model="single_object.fixture_number" max="200" step=".01" pattern="\d+"/>
                    </div>
                </div>

                <div class="row m-0 formdynamic pt-0">
                    <div v-show="single_object.patient" class="col-md-4 py-0 mt-3" v-for="(item, i) in single_object.fixtures" :key="i">
                        <div class="formdynamic__item__field">
                            <label for="Description:" class="modal-label" v-html="`Bed #${i+1}: <b style='color:red;'>*</b>`"/>
                            <input type="text" v-model="item.name" style="max-width: 500px" required/>
                        </div>
                    </div>
                </div>
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources        from    './form_resources'
import ChildFormResources   from    './ChildFormResources'
import FormDynamic          from    '@/components/FormDynamic.vue'
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import CentralButtons       from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',

    props: [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'single_object_backup',
        'global_index',
        'bed_numbers',
        'array_options',
        'breadcrumb',
        'is_description_dynamic',
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format: [],
            form_format2: [],
            global_room_type: {},
            title_modal: '',
            floor_count: 0,
            daily_task_count: 0,
            suggested_floor_type: null,
            first_time: 0,
            first_time_door_number: true,
            fixtures_backup: undefined
        }
    },

    mounted()
    {
    },

    watch:{
        async "single_object.fixture_number" (val, oldVal)
        {
            this.fixtureChange(val, oldVal)
        },

        async "single_object.floor_id"(val)
        {
            if(this.floor_count)
            {
                await this.defaultProjectTaskCoincidence(val, this.single_object.daily_task_id)
            }

            this.suggested_floor_type = this.array_options['floor_id'].find((data) => data.id === this.global_room_type['floor_id'] || null)

            this.floor_count++
        },
        
        async "single_object.description"(val)
        {
            if(val.length == 0 || !val)
            {
               this.is_description_dynamic = false;
            }
            
        },

        async "single_object.daily_task_id"(val)
        {
            if(this.daily_task_count)
            {
            await this.defaultProjectTaskCoincidence(this.single_object.floor_id, val)
            }
            this.daily_task_count++
        },

        'single_object.patient'(val)
        {
            if(val)
            {
                this.fixtures_backup = this.single_object.fixtures ? JSON.parse(JSON.stringify(this.single_object.fixtures)) : []
                this.single_object.fixtures = this.single_object.fixtures ? this.single_object.fixtures.slice(0, 6) : []

                if(this.single_object.fixture_number > 6)
                {
                    this.single_object.fixture_number = 6
                }
                else
                {
                    this.fixtureChange(this.single_object.fixture_number, this.single_object.fixtures.length)
                }
            }
            else
            {
                this.single_object.fixtures = this.fixtures_backup ? this.fixtures_backup : []
                this.fixtures_backup = this.single_object.fixtures ? JSON.parse(JSON.stringify(this.single_object.fixtures)) : []
            }
        },

        "single_object.room_type_id"(val)
        {
            if(val)
            {

                const room_type = this.array_options['room_type_id'].find((data) => data.id === val)
                this.global_room_type = room_type
                const patient = room_type.patient

                this.suggested_floor_type = this.array_options['floor_id'].find((data) => data.id === room_type['floor_id']) 

                if(this.first_time > 0)
                {
                    this.single_object.work_group = room_type.housekeeper;  
                    this.single_object.fixtures = []
                    if(this.single_object.room_type_id === this.single_object_backup.room_type_id)
                    {
                        if(this.single_object_backup.fixtures.length)
                        {
                            this.single_object.fixtures = [...this.single_object_backup.fixtures]
                            this.single_object.fixture_number = this.single_object_backup.fixtures.length
                        }
                        else
                        {
                            this.single_object.fixture_number = room_type.unit
                        }
                    }
                    else
                    {
                        if(room_type.unit)
                        {
                            this.single_object.fixture_number = room_type.unit
                        }
                    }
                }
                

                if(!this.single_object.daily_task_id && room_type.task_id) 
                {
                    this.single_object.daily_task_id = room_type.task_id
                }

                if(this.first_time > 0)
                {   
                    this.single_object.patient = Boolean(patient)
                }
            }

            this.first_time += 1
        },

        'single_object.door_number'(val)
        {
            if(!this.first_time_door_number || val != this.single_object_backup.door_number)
            {
                let number_position = 0

                this.single_object.fixtures.forEach((fixture, index) => 
                {
                    let bed_number = this.bed_numbers[number_position] ? this.bed_numbers[number_position] : ''
                    
                    if(val === '' || val === null)
                    {
                        fixture.name = `${index+1} ${bed_number}`
                        
                    }
                    else
                    {
                        fixture.name = `${val}${bed_number}`
                    }

                    number_position++
                    
                });
            }
            
            this.first_time_door_number = false
        },

        defaultDescription(val)
        {
            if (this.single_object.description === '' || this.is_description_dynamic)
            {
                if(val)
                {
                    this.is_description_dynamic = true;
                    this.single_object.description = val
                }
            }
            else
            {
                this.is_description_dynamic = false;
            }     
            
        },

    },
    
    methods:{

        setChild(child, parent_description)
        {
            this.suggested_floor_type = null
            let titleConcat = child ? `Room update - <span class="supervisor-text-color"> Internal room to ${parent_description} <i class="fa fa-check-circle"/> </span>` : 'Room update'
            this.title_modal = titleConcat
            this.form_format = child ? ChildFormResources.form_format : FormResources.form_format
            this.form_format2 = child ? ChildFormResources.form_format2 : FormResources.form_format2
            this.first_time = 0
            this.first_time_door_number = true
            if(this.single_object_backup.fixtures && this.single_object_backup.fixtures.length)
            {
                this.fixtures_backup = JSON.parse(JSON.stringify(this.single_object_backup.fixtures))
            }
        },

        fixtureChange(val, oldVal)
        {
            if(this.single_object.patient)
            {
                val = val.toString()
                val = val.replace(/[^\d]/g, '');
                this.single_object.fixture_number = val

                if(val.length > 1)
                {
                    val = val.slice(0, 1)
                    this.single_object.fixture_number = val
                    this.notyfMesg('No decimal values allowed', 'error')
                }

                if(this.single_object.fixture_number > 6)
                {
                    val = 6
                    this.single_object.fixture_number = val
                    this.notyfMesg('Up to 6 beds', 'error')
                }


                if(val < oldVal || val < this.single_object.fixtures.length)
                {
                    if(this.single_object.fixtures.length >= val)
                    {
                        this.single_object.fixtures = this.single_object.fixtures.slice(0, val)
                    }
                }
                else
                {
                    let new_beds_number = val - this.single_object.fixtures.length
                    
                    for (let index = 0; index < new_beds_number; index++) 
                    {
                        let number_position = 0
                        let rounds = 0

                        if(this.bed_numbers.length > this.single_object.fixtures.length)
                        {
                            number_position = this.single_object.fixtures.length
                        }
                        else
                        {
                            rounds = Math.floor(this.single_object.fixtures.length / this.bed_numbers.length)
                            number_position = this.single_object.fixtures.length - (rounds * this.bed_numbers.length) + 1
                        }

                        let concat_prefix = ''
                        let bed_number = this.bed_numbers[number_position] || ''

                        if(this.single_object.door_number === '' || this.single_object.door_number === null)
                        {
                            concat_prefix = `${this.single_object.fixtures.length+1} ${bed_number}`
                        }
                        else
                        {
                            concat_prefix = `${this.single_object.door_number}${bed_number}`
                        }

                        concat_prefix = rounds ? `${concat_prefix} | ${rounds}` : concat_prefix

                        if(this.single_object.fixtures.length < 6 || !this.single_object.patient)
                        {
                            this.single_object.fixtures.push({ id: '', name: concat_prefix })
                        } 
                        
                    } 
                }
            }
            else
            {
                if(val > 200)
                {
                    val = 200
                    this.single_object.fixture_number = 200
                    this.notyfMesg('Up to 200 fixtures', 'error')
                }

            }
        },

        includes_areas()
        {
            for (const area of this.array_options.area_id)
            {
                if(this.single_object.description.includes(area.name))
                {
                    return true
                }    
            }
            return false
        },

    },

    computed:
    {
        defaultDescription()
        {
            let area = ''
            let room_type = ''
            if(this.single_object.area_id)
            {
                area = this.array_options.area_id.find(value => value.id == this.single_object.area_id).name
            }

            if(this.single_object.room_type_id)
            {
                room_type = this.array_options.room_type_id.find(value => value.id == this.single_object.room_type_id).abbrevation
            }
            return area + (room_type ? ` ${room_type}` : '') + (this.single_object.door_number ? ` ${this.single_object.door_number}` : '') + (this.single_object.description_2 ?` ${this.single_object.description_2}` : '')
        },
    }
    
}
</script>